export default __webpack_public_path__ + "static/media/icon_fail.36ddbe6b.png";